import { Component } from 'react';
//@ts-ignore
import {
  Widget, toggleMsgLoader, addUserMessage,
  addResponseMessage,
} from '../index';
import socket from '../src/socket/socket';

export default class App extends Component {
  componentDidMount() {
    // addResponseMessage("Здравствуйте! Что вас интересует?")

    socket.subscribe((e) => {
      if (e.type == "message" && (e?.body?.trim() || e?.files?.length)) {
        const senderName = e?.sender_name
        addResponseMessage({ text: e.body, buttons: e?.buttons ?? [], files: e?.files ?? [], senderName: senderName ? `Оператор: ${senderName}` : '', messageId: e.message_id })
      }

      if (e.type === 'history') {
        const { messages = [] } = e.data;

        messages.forEach(message => {
          const datetime = new Date(message.created_at * 1000);

          if (message?.body?.trim() || message?.files?.length) {
            if (message.sender == 0) {
              addUserMessage({text: message.body,  senderName: message?.sender_name || 'Клиент', datetime: datetime, messageId: message.message_id, isAcknowledged: message.acknowledged } )
            } else {
              addResponseMessage({ text: message.body, buttons: message?.buttons ?? [], files: message?.files ?? [], senderName: message?.sender_name, messageId: message.message_id }, datetime)
            }
          }
        })
      }
    });
    // addLinkSnippet({ link: 'https://google.com', title: 'Google' });

  }

  handleNewUserMessage = (newMessage: any) => {
    toggleMsgLoader();
  }

  handleQuickButtonClicked = (e: any) => {
    addResponseMessage({ text: 'Selected ' + e, buttons: [], files: [], senderName: undefined, messageId: '' });
  }

  handleSubmit = (msgText: string) => {

    return true;
  }

  render() {
    return (
      //@ts-ignore
      <Widget
        launcherOpenImg={process.env.IMAGE}
        subtitle={process.env.SUBTITLE}
        titleAvatar={process.env.IMAGE}
        title={process.env.TITLE}
        senderPlaceHolder="Напишите сообщение..."
        handleNewUserMessage={this.handleNewUserMessage}
        handleQuickButtonClicked={this.handleQuickButtonClicked}
        imagePreview
        handleSubmit={this.handleSubmit}
        emojis
      />
    );
  }
}
